import React from 'react';

import { Filter } from '@gogame/filters';

import { FILTER_PERIOD } from 'scenes/KPI/constants';
import { PERIOD_PRESETS } from 'scenes/KPI/constants';

export const Period = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Select Period'}
      presets={PERIOD_PRESETS}
      name={FILTER_PERIOD}
      placeholder={'All'}
      maxDate={new Date()}
      {...props}
    />
  );
};
